import CopyWrapper from "components/Common/CopyWrapper";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import {
  COLOR_PLAN_PURCHASE_INVOICE_TYPE,
  COLOR_PLAN_PURCHASE_PAYMENT_METHOD,
  COLOR_PLAN_PURCHASE_PAYMENT_STATUS,
  ENUM_CASH_RECEIPT_TYPE,
  ENUM_GATEWAY_PAYMENT_METHOD,
  ENUM_PLAN_PURCHASE_PAYMENT_METHOD,
  ENUM_PLAN_PURCHASE_PAYMENT_STATUS,
  LIST_PLAN_PURCHASE_INVOICE_TYPE,
  LIST_PLAN_PURCHASE_PAYMENT_METHOD,
  LIST_PLAN_PURCHASE_PAYMENT_STATUS,
} from "helpers/constans";
import {
  formatDateStringToKorea,
  formatNumberWithCommas,
} from "helpers/format";
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { Button, Card, CardBody, Col, Input, Label, Row, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import userPlanPurchaseApi from "api/userPlanPurchaseApi";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import GatewayVirtualSection from "./component/payment-info/GatewayVirtualSection";
import TransferSection from "./component/payment-info/TransferSection";
import TransactionDetails from "./component/payment-info/TransactionDetails";
import { Link } from "react-router-dom";

registerLocale("en", en);
registerLocale("ko", ko);

const PaymentInfoTab = ({ data, handleUpdateSuccess }: any) => {
  const { t, i18n } = useTranslation();

  const [dataFormat, setDataFormat] = useState<any | null>(null);
  const [lstPlanPaymentStatus, setLstPlanPaymentStatus] = useState<any>([]);
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState<any>("");
  const [paymentNote, setPaymentNote] = useState<string>("");
  const [isLoadingSave, setIsLoadingSave] = useState<boolean>(false);
  const [isOpenTransactionDetail, setIsOpenTransactionDetail] = useState<boolean>(false);
  const [itemTransactionDetail, setItemTransactionDetail] = useState<any>(null);

  const getPlanPaymentStatus = (status: string) => {
    switch (status) {
      case ENUM_PLAN_PURCHASE_PAYMENT_STATUS.PENDING:
        setLstPlanPaymentStatus(
          LIST_PLAN_PURCHASE_PAYMENT_STATUS?.filter((item: any) =>
            [
              ENUM_PLAN_PURCHASE_PAYMENT_STATUS.PENDING,
              ENUM_PLAN_PURCHASE_PAYMENT_STATUS.SUCCEEDED,
              ENUM_PLAN_PURCHASE_PAYMENT_STATUS.FAILED,
            ]?.includes(item?.value)
          )
        );
        break;
      case ENUM_PLAN_PURCHASE_PAYMENT_STATUS.SUCCEEDED:
        setLstPlanPaymentStatus(
          LIST_PLAN_PURCHASE_PAYMENT_STATUS?.filter((item: any) =>
            [
              ENUM_PLAN_PURCHASE_PAYMENT_STATUS.SUCCEEDED,
              ENUM_PLAN_PURCHASE_PAYMENT_STATUS.REFUNDED,
            ]?.includes(item?.value)
          )
        );
        break;
      default:
        setLstPlanPaymentStatus(LIST_PLAN_PURCHASE_PAYMENT_STATUS);
        break;
    }
  };

  const handleActionUpdateStatus = async () => {
    if (!data?.id || !selectedPaymentStatus) return;

    try {
      setIsLoadingSave(true)
      const response: any = await userPlanPurchaseApi.putUserPlanPurchase(
        data?.id, { payment: {
          status: selectedPaymentStatus,
          note: paymentNote
        } 
      });

      if (response?.data) {
        handleUpdateSuccess && handleUpdateSuccess();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    } finally {
      setIsLoadingSave(false)
    }
  };

  const handleCloseTransactionDetail = () => {
    setItemTransactionDetail(null);
    setIsOpenTransactionDetail(false);
  }

  useEffect(() => {
    if (data) {
      getPlanPaymentStatus(data?.payment?.status)
      setSelectedPaymentStatus(data?.payment?.status)
      setPaymentNote(data?.payment?.note)
      const formatGatewayCallBack = data?.payment?.gateways?.find((item: any) => item?.type === "CALLBACK");

      let paymentMethod = data?.payment?.method;
      if(data?.payment?.gatewayPaymentMethod === ENUM_GATEWAY_PAYMENT_METHOD.VIRTUALACCOUNT) {
        paymentMethod = ENUM_PLAN_PURCHASE_PAYMENT_METHOD.TRANSFER_VIRTUAL_ACCOUNT
      }

      setDataFormat({
        amount: data?.plan?.price?.price || "",
        currency: data?.payment?.currency || "",
        totalAmount: data?.payment?.totalAmount || "",
        vat: data?.plan?.price?.vatRate || "",
        paymentMethodLabel: paymentMethod || "",
        paymentMethod: data?.payment?.method || "",
        gatewayPaymentMethod: data?.payment?.gatewayPaymentMethod || "",

        depositorsName: data?.payment?.transfer?.depositorName || "",
        bankName: data?.payment?.transfer?.bankName || "",
        accountNumber: data?.payment?.transfer?.bankAccount || "",
        accountName: data?.payment?.transfer?.bankHolder || "",
        receiptType: data?.payment?.transfer?.receiptType || "",
        receiptEmail: data?.payment?.transfer?.receiptEmail || "",
        depositNote: data?.payment?.transfer?.description || "",

        paymentStatus: data?.payment?.status || "",
        paidAt: data?.payment?.paidAt || "",
        createdAt: data?.createdAt || "",
        note: data?.payment?.note || "",

        gwPGName: data?.payment?.gateways?.[0]?.provider || "",
        transactionId: data?.payment?.gateways?.[0]?.transactionId || "",
        gwPGTransactionId: data?.payment?.transferVirtualAccount?.TID || "",
        gwBankName: data?.payment?.transferVirtualAccount?.bankName || "",
        gwBankCode: data?.payment?.transferVirtualAccount?.bankCode || "",
        gwVirtualAccountNo: data?.payment?.transferVirtualAccount?.virtualAccountNo || "",
        gwVirtualAccountName: data?.payment?.transferVirtualAccount?.virtualAccountName || "",
        gwVirtualAccountExpiredAt: data?.payment?.transferVirtualAccount?.virtualAccountExpiredAt || "",
        gwReceiptType: data?.payment?.receiptType || "",

        taxInvoice: data?.payment?.taxInvoice || "",
        cashReceipt: data?.payment?.cashReceipt || "",
        cashReceiptType: data?.payment?.cashReceipt?.type || "",
        cashAuthNO: data?.payment?.cashReceipt?.CashAuthNO || "",
        cashCardNo: data?.payment?.cashReceipt?.cashCardNo || "",
        cashYN: data?.payment?.cashReceipt?.CashYN || "",
        remitter: data?.payment?.cashReceipt?.CashYN || "",

        dMxIssueDate: formatGatewayCallBack?.createdAt || "",
        dMxIssueNO: formatGatewayCallBack?.response?.MxIssueNO || "",
        dVactNo: formatGatewayCallBack?.response?.VactNo || "",
        dAmount: formatGatewayCallBack?.response?.Amount || "",
        dCashReceiptType: (formatGatewayCallBack?.response?.CashReceiptType === 0 ? ENUM_CASH_RECEIPT_TYPE.PERSONAL :  (formatGatewayCallBack?.response?.CashReceiptType === 1 ? ENUM_CASH_RECEIPT_TYPE.BUSINESS : "")) || "",
        dCashYN: formatGatewayCallBack?.response?.CashYN || "",
        dCashCardNO: formatGatewayCallBack?.response?.CashCardNO || "",
        dCashAuthNO: formatGatewayCallBack?.response?.CashAuthNO || "",
        dRemitter: formatGatewayCallBack?.response?.Remitter || "",
      });
    }
  }, [JSON.stringify(data)]);

  useEffect(() => {
    document.title = `${t("Account Info")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <Row>
        <Col lg={12} className="mt-4 px-4">
          <div>
           
              <div className="d-flex flex-column flex-lg-row gap-3 gap-lg-4">
                <div className="flex-grow-1">
                  <Row>
                    <Col md={12} lg={12}>
                      <Card>
                        <CardBody>
                          <Row>
                            {/* {dataFormat?.paymentMethod === ENUM_PLAN_PURCHASE_PAYMENT_METHOD.GATEWAY && ( */}
                            <Col md={4} lg={4}>
                              <div className="mb-3">
                                <Label htmlFor="transactionId" className="form-label">
                                  {t("Transaction ID")}
                                </Label>
                                <div className="cursor-pointer">
                                  <CopyWrapper
                                    contentCopy={dataFormat?.transactionId}
                                  >
                                    {`${dataFormat?.transactionId || "-"}`}
                                  </CopyWrapper>
                                </div>
                              </div>
                            </Col>
                            {/* )} */}

                            <Col md={4} lg={4}>
                              <div className="mb-3">
                                <Label htmlFor="address" className="form-label">
                                  {t("Total Amount")}
                                </Label>
                                <div>
                                  {formatNumberWithCommas(
                                    dataFormat?.totalAmount
                                  ) || "-"}{" "}
                                  {dataFormat?.currency === "KRW" ? "₩" : (dataFormat?.currency || "")}
                                </div>
                              </div>
                            </Col>

                            <Col md={4} lg={4}>
                              <div className="mb-3">
                                <Label htmlFor="createdAt" className="form-label">
                                  {t("Created at")}
                                </Label>
                                <div>
                                  {dataFormat?.createdAt
                                    ? formatDateStringToKorea(dataFormat?.createdAt)
                                    : "-"}
                                </div>
                              </div>
                            </Col>

                            <Col md={4} lg={4}>
                              <div className="mb-3 mt-2">
                                <Label htmlFor="field" className="form-label">
                                  {t("Payment Method")}{" "}
                                </Label>
                                <div>
                                  <span
                                    className={`rounded-pill badge bg-${
                                      COLOR_PLAN_PURCHASE_PAYMENT_METHOD[
                                        dataFormat?.paymentMethodLabel
                                      ] || "secondary"
                                    }`}
                                    style={{
                                      fontSize: "0.8rem",
                                      lineHeight: 1
                                    }}
                                  >
                                    {t(
                                      LIST_PLAN_PURCHASE_PAYMENT_METHOD?.find(
                                        (item: any) =>
                                          String(item?.value) ===
                                          String(dataFormat?.paymentMethodLabel)
                                      )?.label || ""
                                    )}
                                  </span>
                                </div>
                              </div>
                            </Col>

                            {dataFormat?.paymentMethod === ENUM_PLAN_PURCHASE_PAYMENT_METHOD.TRANSFER && (
                              <TransferSection dataFormat={dataFormat} />
                            )}

                            {
                              (dataFormat?.paymentMethod === ENUM_PLAN_PURCHASE_PAYMENT_METHOD.GATEWAY && dataFormat?.gatewayPaymentMethod === ENUM_GATEWAY_PAYMENT_METHOD.CREDITCARD) && (
                                <>
                                  <Col md={4} lg={4}>
                                    <div className="mb-3 mt-2">
                                      <Label
                                        htmlFor="gwPGName"
                                        className="form-label"
                                      >
                                        {t("PG Name")}
                                      </Label>
                                      <div className="cursor-pointer">
                                        <CopyWrapper
                                          contentCopy={dataFormat?.gwPGName}
                                        >
                                          {`${t(dataFormat?.gwPGName) || "-"}`}
                                        </CopyWrapper>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md={4} lg={4}></Col>
                                </>
                              )
                            }

                            {(dataFormat?.paymentMethod === ENUM_PLAN_PURCHASE_PAYMENT_METHOD.GATEWAY && dataFormat?.gatewayPaymentMethod === ENUM_GATEWAY_PAYMENT_METHOD.VIRTUALACCOUNT) && (
                              <GatewayVirtualSection dataFormat={dataFormat} />
                            )}

                            <Col md={4} lg={4}>
                              <div className="mb-3 mt-2">
                                <Label
                                  htmlFor="payment-status"
                                  className="form-label"
                                >
                                  {t("Payment Status")}{" "}
                                  <span className="text-danger">*</span>
                                </Label>

                                {([
                                  ENUM_PLAN_PURCHASE_PAYMENT_STATUS.PENDING,
                                  ENUM_PLAN_PURCHASE_PAYMENT_STATUS.SUCCEEDED,
                                  ].includes(dataFormat?.paymentStatus) && 
                                  dataFormat?.paymentMethod !== ENUM_PLAN_PURCHASE_PAYMENT_METHOD.FREE) ? (
                                    <DropdownStatusNew
                                      name="payment-status"
                                      dataList={lstPlanPaymentStatus}
                                      placeholder={`${t("Status")}...`}
                                      className="dropdown-status-rounded"
                                      classNamePrefix="name-prefix"
                                      initialValue={selectedPaymentStatus}
                                      onChangeSelect={(e: any) => {
                                        if (e?.value !== dataFormat?.paymentStatus) {
                                          setSelectedPaymentStatus(e?.value);
                                        }
                                      }}
                                      isHasOptionAll={false}
                                      colors={COLOR_PLAN_PURCHASE_PAYMENT_STATUS}
                                    />
                                  ): (
                                    <div>
                                      <span
                                        className={`rounded-pill badge bg-${
                                          COLOR_PLAN_PURCHASE_PAYMENT_STATUS[dataFormat?.paymentStatus] || "secondary"
                                        }`}
                                        style={{
                                          fontSize: "0.8rem",
                                          lineHeight: 1
                                        }}
                                      >
                                        {t(
                                          LIST_PLAN_PURCHASE_PAYMENT_STATUS?.find(
                                            (item: any) => (item?.value) == (dataFormat?.paymentStatus)
                                          )?.label || ""
                                        )}
                                      </span>
                                    </div>
                                  )
                                }
                              </div>
                            </Col>
                            
                            {
                              dataFormat?.paymentStatus === ENUM_PLAN_PURCHASE_PAYMENT_STATUS.SUCCEEDED && (
                                <Col md={4} lg={4}>
                                  <div className="mb-3 mt-2">
                                    <Label htmlFor="paidAt" className="form-label">
                                      {t("Paid at")}
                                    </Label>
                                    <div>
                                      {dataFormat?.paidAt
                                        ? formatDateStringToKorea(dataFormat?.paidAt)
                                        : "-"}
                                    </div>
                                  </div>
                                </Col>
                              )
                            }

                            {(
                              dataFormat?.paymentMethod === ENUM_PLAN_PURCHASE_PAYMENT_METHOD.GATEWAY && 
                              dataFormat?.gatewayPaymentMethod === ENUM_GATEWAY_PAYMENT_METHOD.VIRTUALACCOUNT && 
                              [
                                ENUM_PLAN_PURCHASE_PAYMENT_STATUS.FAILED,
                                ENUM_PLAN_PURCHASE_PAYMENT_STATUS.SUCCEEDED,
                              ].includes(dataFormat?.paymentStatus)
                            ) && (
                              <Col md={4} lg={4} className="d-flex align-items-end mb-3">
                                <Link
                                  to={"#"}
                                  className="btn btn-link mt-2"
                                  style={{
                                    border: "1px solid #009ef7",
                                    overflow: "hidden",
                                    borderRadius: "var(--vz-border-radius)",
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setIsOpenTransactionDetail(true)
                                    setItemTransactionDetail(dataFormat)
                                  }}
                                  >
                                    {t("Transaction Details")}
                                </Link>
                              </Col>
                            )}

                            <Col lg={12}>
                              <div className="mb-3">
                                <Label htmlFor="note" className="form-label">
                                  {t("Note")}
                                </Label>

                                <div className="d-flex mb-2 gap-2">
                                  <textarea
                                    className="form-control"
                                    name={`note`}
                                    maxLength={1000}
                                    value={paymentNote || ""}
                                    placeholder={`${t("Note")}`}
                                    onChange={(event) => {
                                      setPaymentNote(event?.target?.value);
                                    }}
                                    style={{ height: 80 }}
                                  />
                                </div>
                              </div>
                            </Col>

                            <Col lg={12}>
                              <div className="hstack gap-2 justify-content-end">
                                <button type="button" className="btn btn-primary fs-14"
                                  onClick={() => {
                                    handleActionUpdateStatus()
                                  }}
                                >
                                  {isLoadingSave && (
                                    <Spinner size="sm" className="me-2"></Spinner>
                                  )}
                                  {t("Button Save")}
                                </button>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </div>
              </div>

              <Row className="mt-3"></Row>
          </div>
        </Col>
      </Row>

      {
        isOpenTransactionDetail && (
          <TransactionDetails
            item={itemTransactionDetail}
            handleClose={handleCloseTransactionDetail}
          />
        )
      }
    </React.Fragment>
  );
};

export default PaymentInfoTab;
